export default "__VITE_ASSET__bkbnwE3a__"